<template>
  <div class="import-technical-sales" xmlns:v-on="http://www.w3.org/1999/xhtml">
    <c-import-base
      :importFileService="technicalSaleService"
      :csvProperties="csvProperties"
      :pageTitle="`${$t('ctx.import.sales__title')}`"
      :uploadButtonLabel="`${$t('ctx.import.sales__description')}`"
      :importInformation="importInformation"
      help-link="https://support.invivodigitalfactory.com/hc/articles/15890445902620"
      @afterLoading="afterTechnicalSalesImport"
    >
      <c-import-information
        :title="`${$t('ctx.import.sales__informations')}`"
        :nbResultText="`${$t('ctx.import.sales__count')} :`"
        :exportText="`${$t('ctx.import.sales__export-action')}`"
        :importInformation="importInformation"
        :downloadCSV="downloadCSV"
      >
      </c-import-information>
    </c-import-base>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { provideUploadCondition, CImportBase, CImportInformation } from '@invivodf/common/src/contexts/parameters'
import { useI18nForVue2 } from '@invivodf/locales/src/useI18n'
import { cooperativeService, technicalSaleService } from '../../services'

const csvFileProperties = {
  name: 'technicians.csv',
  full_path: '/assets/csv/technicians.csv',
}
export default {
  name: 'CImportTechnicalSales',
  setup() {
    const i18n = useI18nForVue2()
    const { setUploadCondition } = provideUploadCondition(i18n)
    return { setUploadCondition }
  },
  computed: {
    ...mapGetters(['technicalSalesImportInformation', 'cooperativeId', 'cooperative']),
    importInformation() {
      const { technicalSalesImportInformation: { technicalSalesCount, lastTechnicalSalesImportAt } = {} } = this
      return { count: technicalSalesCount, lastImportAt: lastTechnicalSalesImportAt }
    },
  },
  components: {
    CImportBase,
    CImportInformation,
  },
  methods: {
    afterTechnicalSalesImport() {
      this.$store.dispatch('setTechnicalSalesImportInformation')
    },
    downloadCSV() {
      return cooperativeService.downloadTechnicalSales(this.cooperativeId, this.cooperative.name)
    },
  },
  data() {
    return {
      csvProperties: csvFileProperties,
      technicalSaleService,
    }
  },
  beforeMount() {
    this.setUploadCondition('ctx.import.sales__separation-law')
  },
}
</script>
